(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-modal"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('shared-contact-modal')) return;
  const storageKey = 'shared-contact-modal:submission:v1';
  const readPending = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(storageKey));
      if (value && value.path === location.pathname && Date.now() - value.time < 1800000) return value;
    } catch (_) { /* Storage may be unavailable in private browsing. */ }
    return null;
  };
  const clearPending = () => {
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
  };

  class SharedContactModal extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.initialize();
        this.handleResult();
      });
    }

    initialize() {
      if (this.controller) return;
      this.dialog = this.querySelector('[data-modal]');
      if (!this.dialog) return;
      this.form = this.dialog.querySelector('form');
      this.success = this.querySelector('[data-success-message]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog.querySelector('[data-modal-close]').addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      }, options);
      // Only close a backdrop click, not a drag from a field to the backdrop.
      const outside = (event) => {
        const r = this.dialog.getBoundingClientRect();
        return event.target === this.dialog &&
          (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom);
      };
      this.dialog.addEventListener('pointerdown', (event) => { this.backdropDown = outside(event); }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropDown && outside(event)) this.close();
        this.backdropDown = false;
      }, options);
      this.dialog.addEventListener('close', () => {
        // A queued close event must not unlock a dialog reopened in the meantime.
        if (!this.dialog.open) this.releaseFocusAndScroll();
      }, options);
      this.form.addEventListener('submit', () => {
        // Do not preventDefault or submit via fetch: leave Shopify CAPTCHA and POST intact.
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({
            key: this.dataset.modalKey,
            trigger: this.opener ? this.opener.id : '',
            path: location.pathname,
            time: Date.now()
          }));
        } catch (_) {}
      }, { ...options, capture: true });
      this.addEventListener('shopify:block:select', () => this.open(), options);
      this.addEventListener('shopify:block:deselect', () => this.close(), options);
    }

    open(trigger) {
      this.initialize();
      if (!this.dialog || this.dialog.open) return;
      document.querySelectorAll('shared-contact-modal').forEach((host) => {
        if (host !== this && typeof host.close === 'function') host.close();
      });
      this.opener = trigger || null;
      if (trigger) trigger.setAttribute('aria-controls', this.dialog.id);
      this.dialog.showModal();
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.scrollLocked = true;
    }

    releaseFocusAndScroll() {
      if (!this.scrollLocked) return;
      document.body.style.overflow = this.savedOverflow;
      this.scrollLocked = false;
      if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
    }

    close() {
      if (!this.dialog || !this.dialog.open) return;
      this.dialog.close();
      this.releaseFocusAndScroll();
    }

    handleResult() {
      if (this.resultHandled || !this.form) return;
      this.resultHandled = true;
      const pending = readPending();
      const matchingPending = pending && pending.key === this.dataset.modalKey;
      const url = new URL(location.href);
      const errors = this.form.querySelector('[data-contact-errors]');
      const serverSuccess = this.form.querySelector('[data-contact-success]');
      const matchesAnchor = url.hash === '#' + this.form.id;
      const firstModal = document.querySelector('shared-contact-modal') === this;
      // Prefer the submitting modal; without storage, use its form anchor or the single modal.
      const ownsResult = pending ? matchingPending : (matchesAnchor || firstModal);
      if (!ownsResult) return;
      const candidate = matchingPending ? document.getElementById(pending.trigger) : null;
      const trigger = candidate && candidate.dataset.contactModalTrigger === this.dataset.modalKey ? candidate : null;
      if (errors) {
        this.open(trigger);
        errors.focus();
        clearPending();
        return;
      }
      if (!serverSuccess && !(matchingPending && url.searchParams.get('contact_posted') === 'true')) return;
      clearPending();
      this.form.reset();
      if (trigger) {
        trigger.insertAdjacentElement('afterend', this.success);
        this.success.setAttribute('data-near-trigger', '');
      }
      // Reveal an existing live region after initialization.
      this.success.hidden = false;
      if (trigger) {
        trigger.focus({ preventScroll: true });
        trigger.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
      this.successTimer = setTimeout(() => { this.success.hidden = true; }, 10000);
      url.searchParams.delete('contact_posted');
      if (matchesAnchor) url.hash = '';
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      clearTimeout(this.successTimer);
      this.close();
      if (this.controller) this.controller.abort();
      this.controller = null;
      if (this.success) {
        this.success.hidden = true;
        this.success.removeAttribute('data-near-trigger');
        this.appendChild(this.success);
      }
    }
  }

  customElements.define('shared-contact-modal', SharedContactModal);
  // One delegated listener supports any number of buttons, including editor inserts.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-modal-trigger]');
    if (!trigger) return;
    const modal = Array.from(document.querySelectorAll('shared-contact-modal')).find(
      (host) => host.dataset.modalKey === trigger.dataset.contactModalTrigger
    );
    if (!modal) {
      console.warn('Contact modal: add a Contact modal block with Modal key "' + trigger.dataset.contactModalTrigger + '" on this page.');
      return;
    }
    event.preventDefault();
    modal.open(trigger);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
